import { Container, Sprite } from 'pixi.js'

export default class SnowFlakeParticle {
  private sprite: Sprite
  private parentCont: Container
  private maxX: number
  private maxY: number
  private xMargin: number
  private xSpeedMultiplier: number
  private ySpeedMultiplier: number

  constructor(parentContainer: Container, containerWidth: number, containerHeight: number) {
    this.parentCont = parentContainer
    this.maxX = containerWidth
    this.maxY = containerHeight
    this.xMargin = this.maxX / 3

    this.xSpeedMultiplier = 0.0
    this.ySpeedMultiplier = 0.0

    this.sprite = Sprite.from('p-snow.png')
  }

  public reset(randomizeY: boolean): void {
    this.parentCont.addChild(this.sprite)
    this.sprite.x = Math.random() * (this.maxX + 2 * this.xMargin) - this.xMargin
    this.sprite.alpha = 0.3 + Math.random() * 0.7
    const scale: number = 0.3 + Math.random() * 0.5
    this.sprite.scale.x = scale
    this.sprite.scale.y = scale
    this.xSpeedMultiplier = -0.1 + Math.random() * 0.2
    this.ySpeedMultiplier = 0.25 + Math.random() * 0.25

    if (randomizeY) {
      this.sprite.y = Math.random() * this.maxY
    } else {
      this.sprite.y = -10 - Math.random() * 10 //todo ???
    }
  }

  public remove(): void {
    this.parentCont.removeChild(this.sprite)
  }

  public move(fallSpeed: number, xSpeed: number = 0): boolean {
    this.sprite.x += this.xSpeedMultiplier + xSpeed
    this.sprite.y += this.ySpeedMultiplier * fallSpeed

    if (this.sprite.y > this.maxY) {
      this.remove()
      return false
    }
    return true
  }
}
